module.exports = __webpack_public_path__ + "img/t_0010.933aec6a.gif";